import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // getActiveShiftsOverviewRequest: null,
  // getActiveShiftsOverviewSuccess: ['response'],
  // getActiveShiftsOverviewFailure: null,

  getShiftPrevPeriodOverviewRequest: ['shiftId'],
  getShiftPrevPeriodOverviewSuccess: ['response'],
  getShiftPrevPeriodOverviewFailure: null,

  getShiftCommissionsRequest: ['shiftId'],
  getShiftCommissionsSuccess: ['response'],
  getShiftCommissionsFailure: null,

  // getShiftAlertsFeedRequest: ['id'],
  // getShiftAlertsFeedSuccess: ['response'],
  // getShiftAlertsFeedFailure: null,

  saveAllInfractionsRequest: null,
  saveAllInfractionsSuccess: ['response'],
  saveAllInfractionsFailure: null,

  // getShiftAlertsPaginationFeedRequest: ['payload'],
  // getShiftAlertsPaginationFeedSuccess: ['response'],
  // getShiftAlertsPaginationFeedFailure: null,

  saveUserInfractionAsRecordRequest: ['feedId'],
  saveUserInfractionAsRecordSuccess: ['feedId'],
  saveUserInfractionAsRecordFailure: null,

  deleteUserInfractionRequest: ['feedId'],
  deleteUserInfractionSuccess: ['feedId'],
  deleteUserInfractionFailure: null,

  // getShiftChecklistFeedRequest: ['page', 'limit', 'id'],
  // getShiftChecklistFeedSuccess: ['response'],
  // getShiftChecklistFeedFailure: null,

  markFailedChecklistAsCompletedRequest: ['feedId'],
  markFailedChecklistAsCompletedSuccess: ['feedId'],
  markFailedChecklistAsCompletedFailure: null,

  getShiftHotListFeedRequest: ['branchId'],
  getShiftHotListFeedSuccess: ['response'],
  getShiftHotListFeedFailure: null,

  updateHotListVehicleCommentRequest: ['feedId', 'commentId', 'payload'],
  updateHotListVehicleCommentSuccess: ['feedId', 'comment'],
  updateHotListVehicleCommentFailure: ['feedId', 'commentId'],

  deleteHotListVehicleCommentRequest: ['feedId', 'commentId'],
  deleteHotListVehicleCommentSuccess: ['feedId', 'commentId'],
  deleteHotListVehicleCommentFailure: ['feedId', 'commentId'],

  archiveManualHotListRequest: ['feedId'],
  archiveManualHotListSuccess: ['feedId'],
  archiveManualHotListFailure: null,

  // Clear all caches
  clearShiftAdminRequest: null,
});

export const ShiftAdminTypes = Types;
export default Creators;
